<template>
  <section> 
    <b-row>
      <b-col md="12">
        <b-card
          style="max-width: 80%">
          <template v-slot:header >
            <div class="header-card text-center">
              <h5>Comprobantes de Liquidación</h5>
              <span class="sw-card-header"></span>
            </div>          
          </template>         
            <b-nav tabs>
              <b-nav-item :active="active===0" @click="active=0">Crear liquidación</b-nav-item>
              <b-nav-item :active="active===1" @click="active=1;"  class="d-none d-md-block">Historial de liquidaciones</b-nav-item>
            </b-nav>  
            <div v-show="active===0" style="border:1px solid; border-top:none;border-color: #dee2e6;">
              <b-form  inline novalidate> 
                <validation-observer v-slot="{ invalid } ">       
                  <b-row  class="p-2">
                    <sw-inputs
                      inputTabla="info_liquidacion"
                      inputCampo="id_datos_razon"
                      :sm="12"
                      :md="6"
                      :lg="4"
                      >
                    </sw-inputs>
                    <b-col :lg="4">
                    </b-col>
                  <sw-inputs
                      inputTabla="info_liquidacion"
                      inputCampo="fecha"
                      :sm="12"
                      :md="6"
                      :lg="4"
                      >
                    </sw-inputs> 
                    <b-col :lg="12">
                      <h6 class="title-form">Datos Del Afiliado</h6>
                    </b-col> 
                    <sw-searchs
                          :sm="12"
                          :md="6"
                          :lg="8"
                          :append="true"
                          label='Seleccionar afiliado'
                          list='datos_afiliado'
                          @input="watchAfiliado"
                          @append="limpiarAfiliado"
                          >
                    </sw-searchs>  
                    <sw-inputs
                      inputTabla="info_liquidacion"
                      inputCampo="fechaini"
                      :sm="12"
                      :md="6"
                      :lg="4"
                      >
                    </sw-inputs>
                    <sw-inputs
                      inputTabla="info_liquidacion"
                      inputCampo="id_list_documento"
                      :sm="12"
                      :md="6"
                      :lg="4"
                      >
                    </sw-inputs>        
                    <sw-inputs
                      inputTabla="info_liquidacion"
                      inputCampo="documento"
                      :sm="12"
                      :md="6"
                      :lg="4"
                      >
                    </sw-inputs>
                    <sw-inputs
                      inputTabla="info_liquidacion"
                      inputCampo="fechafin"
                      :sm="12"
                      :md="6"
                      :lg="4"
                      >
                    </sw-inputs>
                    <sw-inputs
                      inputTabla="info_liquidacion"
                      inputCampo="cargo"
                      :sm="12"
                      :md="6"
                      :lg="4"
                      >
                    </sw-inputs>
                    <sw-inputs
                      inputTabla="info_liquidacion"
                      inputCampo="salario"
                      :sm="12"
                      :md="6"
                      :lg="4"
                      >
                    </sw-inputs> 
                    <sw-inputs
                      inputTabla="info_liquidacion"
                      inputCampo="transporte"
                      :sm="6"
                      :md="6"
                      :lg="4"
                      >
                    </sw-inputs> 
                    <b-col 
                      :cols="12" 
                      class="px-0 py-4 text-right">
                      <b-button
                        @click="changeValues()"
                        type="button"
                        :disabled="!dataForm[namePath].info_liquidacion.fechaini && !dataForm[namePath].info_liquidacion.fechafin"
                        variant="info">
                        Calcular Liquidación
                      </b-button>
                    </b-col>
                    <b-col :lg="7" v-if="searchSw.value!=''">
                      <h6 class="title-form">Devengado</h6>
                        <sw-tableform
                          :tableItems="devengadosItems"
                          tableTabla="liquidacion_devengados"
                          :tableCampos="['id','id_info_liquidacion','concepto','valor','predeterminado']"
                          :inits="devengadosInits"
                          >                         
                        </sw-tableform>
                      </b-col>  
                    <b-col :lg="5" style="margin-bottom: 20px"  v-if="searchSw.value!=''">
                      <h6 class="title-form">Deducidos</h6>
                        <sw-tableform
                          :tableItems="deducidosItems"
                          tableTabla="liquidacion_deducidos"
                          :tableCampos="['id','id_info_liquidacion','concepto','valor','predeterminado']"
                          >                         
                        </sw-tableform>
                      </b-col> 
                      <b-col
                        :md="8"
                        :lg="8">
                      </b-col> 
                      <b-input-group size="sm" prepend="Total: $">
                        <vue-numeric 
                          separator="."   
                          class="form-control"       
                          v-model="totalLiquidacion"
                          disabled>
                        </vue-numeric>  
                      </b-input-group>
                  </b-row> 
                  <b-row> 
                      <b-col class="card-footer">
                        <sw-saveform
                          :invalid="invalid"
                          limpiar
                          :index="dataIndex[namePath]"
                          @save="saveForm"
                          @limpiar="limpiarAfiliado">
                        </sw-saveform> 
                      </b-col>
                  </b-row> 
                </validation-observer>
              </b-form> 
            </div> 
            <div v-if="active==1" class="p-3" style="border:1px solid; border-top:none;border-color: #dee2e6;">
              <sw-tableget
                :filterShow="false"
                :tableItems="tableGBItems"
                :tableSearch="tableGBSearch"
                :tableOptions="tableGBoptions"
                route="get_liquidacion"
                :dataRoute="{others: []}"
                name="tableinfo_liquidacion"
                @filtrar="getFiltrar"
                >               
               <template v-slot:modal>
                  <sw-modalinactive
                    @save="saveForm"
                    >
                  </sw-modalinactive>  
                </template>
              </sw-tableget>     
            </div>          
        </b-card>
        </b-col>
    </b-row>          
  </section>
</template>

<script>
import indexMix  from './indexMix.js'
import storeMix  from './storeMix.js'
import tableMix  from './tableMix.js'
import saveMix  from './saveMix.js'
import saveMixins  from '@/mixings/save.js'
import SwInputs from '@/components/forms/inputs.vue'
import SwInputstables from '@/components/forms/inputsTable.vue'
import SwSaveform from '@/components/forms/saveForm.vue'
import SwTableget from '@/components/dataTable/tableGet.vue'
import SwSearchs from '@/components/forms/searchs.vue'
import SwModalinactive from '@/components/modals/inactive.vue'
import SwTableform from '@/components/dataTable/tableForm.vue'
import VueNumeric   from 'vue-numeric'

export default { 
  name: "facturacion_nomina",
  mixins: [indexMix,storeMix,tableMix,saveMix,saveMixins,],
  components: {
  SwInputs,
  SwSaveform,
  SwTableget,
  SwModalinactive, 
  SwTableform,
  SwInputstables,
  SwSearchs,
  VueNumeric
     
  }
}
</script>
<style>
.nav-tabs .nav-link.active, .nav-tabs .nav-item.show .nav-link
{
  background: #fcfcfc;
  font-weight: 500;
}
</style>
